import type { FaireProductEntity } from "../../entity_types/product";

export const p_asbvjdrpwc: FaireProductEntity = {
  token: "p_asbvjdrpwc",
  type: "product",
  name: "Matcha Honey Lemonade | 8 oz Candle with Wood Lid",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/2e982119eccd81ad76715132adb2fc5c67d5c573e28ec43392aa7e66183d86a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/afaf618d7da316d4f398a112aae24e4a80651955580595323d45a59c65c6cb78.jpeg",
    "https://cdn.faire.com/fastly/d45e68675524ca0b29b78a3dcb2edb8276c12bbac44595b25d29889a35779055.png",
    "https://cdn.faire.com/fastly/54d77a3f604bbc9569c689aaf7f6fa08f6efc71521d9a9d99820f7a3a803f3c7.png",
    "https://cdn.faire.com/fastly/07d801ec0e2dfa147d3e24a2a0fa0f22bb3c84bfd16defed3ad81ae4fd434703.png",
    "https://cdn.faire.com/fastly/7311a38cd75eadbe02688727b4688bae8e86a9129b267f9852bbce116cdd160a.png",
  ],
  priceDollars: 16,
  description:
    "A fusion of earthy matcha, zesty lemon, ginger, jasmine and sweet honey creates a refreshing, invigorating aroma.\n\nTop: Bergamot, Honey, Ginger Zest\nHeart: Lemon Verbena, Jasmine Tea, Violet Leaf\nBase: Matcha Powder, Lemonade, Pear Skin\n\nSize options:\n8 oz. wood wicked iridescent glass jar with a wood lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\nWhy Kandlery?\n- Natural Coconut Wax\n- Crackling Wooden Wick, Made from FSC Certified Wood. \n- Lead free & Self-trimming Cotton Wick\n- Non Toxic Ingredients\n- Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n- Cruelty Free\n- Handcrafted in Small Batch\n- Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:10.258Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
